import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { PainterTermsFull } from '../components/terms/PainterTermsFull';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
      <Helmet>
        <title>Terms & Conditions | SCI Paints BONDHU</title>
        <meta name="description" content="Read the official Terms and Conditions for the SCI Paints BONDHU loyalty program. Understand your rights, rewards eligibility, and platform usage guidelines." />
      </Helmet>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 50,
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: '#f3f4f6',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#e5e7eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#f3f4f6';
          }}
        >
          <ArrowLeftIcon style={{ width: '20px', height: '20px', color: '#111827' }} />
        </button>
        <h1 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', margin: 0 }}>
          SCI Paints BONDHU - Terms & Conditions
        </h1>
      </div>

      <div
        style={{
          padding: '24px 16px',
          paddingBottom: 'calc(24px + 72px + env(safe-area-inset-bottom))'
        }}
      >
        <PainterTermsFull />
      </div>
    </div>
  );
};

export default TermsAndConditions;

